import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';

export default function AutocompleteInput(props) {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [inputValue, setInputValue] = React.useState('');

  const [state, setState] = React.useState({
    typing: false,
    typingTimeout: 0,
  });

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  const fetchItems = () => {
    setLoading(true);
    if (state.typingTimeout) {
      clearTimeout(state.typingTimeout);
    }

    setState({
      typing: false,
      typingTimeout: setTimeout(() => {
        props.searchFunction(inputValue)
          .then((response) => {
            setOptions(response.data);
            setLoading(false);
          });
      }, 2000),
    });
  };

  const handleChange = (value) => {
    props.onChange(props.name, value);
  };

  const isCity = (option) => {
    if (option.city !== null && option.code !== null) {
      return true;
    }
    return false;
  };

  const fetchLabel = (option) => {
    if (option.state) {
      if (isCity(option)) {
        return `${option.city}, ${option.uf}`;
      }
      return `${option.state}`;
    }

    return '';
  };

  const isSelected = (option, value) => {
    if (isCity(option)) {
      return option.code === value.code;
    }

    return option.state === value.state && option.uf === value.uf;
  };

  return (
    <FormControl margin="normal" fullWidth style={{ alignSelf: 'baseline' }}>
      <Autocomplete
        value={props.value}
        // onChange={handleChange}
        onChange={(_, value) => handleChange(value)}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
        id={`${props.name}-autocomplete`}
        open={open}
        onOpen={() => { setOpen(true); }}
        onClose={() => { setOpen(false); }}
        getOptionSelected={isSelected || ''}
        getOptionLabel={fetchLabel || ''}
        options={options}
        loading={loading}
        disabled={props.disabled}
        loadingText="Buscando..."
        noOptionsText={props.instruction}
        renderInput={params => (
          <TextField
            {...params}
            label={props.label}
            InputProps={{
              ...params.InputProps,
              onKeyUp: fetchItems,
              endAdornment: (
                <React.Fragment>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </FormControl>
  );
}
